export default __webpack_public_path__ + "static/media/jaipur.f0874f86.jpg";